import React from 'react';
import { useDarkMode } from '../../../context/DarkModeContext';
import { MailIcon, PlusIcon, UsersIcon, MousePointerIcon, EyeIcon, MoreVerticalIcon, FileTextIcon, SendIcon, ClockIcon } from 'lucide-react';
import BackButton from '../../../components/UI/BackButton';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
import { useRoleTheme } from '../../../hooks/useRoleTheme';
const EmailCampaigns = () => {
  const {
    darkMode
  } = useDarkMode();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const stats = [{
    label: 'Total Subscribers',
    value: '2,450',
    icon: UsersIcon,
    color: 'text-blue-500'
  }, {
    label: 'Avg. Open Rate',
    value: '42%',
    icon: EyeIcon,
    color: 'text-green-500'
  }, {
    label: 'Avg. Click Rate',
    value: '12%',
    icon: MousePointerIcon,
    color: 'text-purple-500'
  }];
  const campaigns = [{
    id: 1,
    name: 'October Newsletter',
    subject: 'Spooky reads for Halloween 🎃',
    status: 'Sent',
    date: 'Oct 15, 2023',
    opens: '45%',
    clicks: '14%',
    type: 'Newsletter'
  }, {
    id: 2,
    name: 'Silent Echo Release Blast',
    subject: 'IT IS HERE! The Silent Echo is live!',
    status: 'Sent',
    date: 'Sep 28, 2023',
    opens: '58%',
    clicks: '22%',
    type: 'Release'
  }, {
    id: 3,
    name: 'November Updates',
    subject: 'Writing updates + Cover Reveal',
    status: 'Scheduled',
    date: 'Nov 1, 2023',
    opens: '-',
    clicks: '-',
    type: 'Newsletter'
  }, {
    id: 4,
    name: 'Black Friday Sale Tease',
    subject: 'Get ready for our biggest sale...',
    status: 'Draft',
    date: 'Last edited 2 days ago',
    opens: '-',
    clicks: '-',
    type: 'Sale'
  }];
  return <div className={`min-h-screen py-8 ${dk.page}`} data-id="element-19700" data-mp="l9jb7qpxhmdx">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19701" data-mp="lab3oso8b3zz">
        <div className="flex justify-between items-center mb-8" data-id="element-19702" data-mp="v61k5n63y4zf">
          <div className="flex items-center gap-4" data-id="element-19703" data-mp="v35ns39wrod3">
            <BackButton data-id="element-19704" data-mp="q7i05sb2r39p" />
            <h1 className={`text-3xl font-bold ${dk.textHeading}`} data-id="element-19705" data-mp="q785vsizy9y7">
              Email Campaigns
            </h1>
          </div>
          <button className={`px-4 py-2 rounded-md transition-colors flex items-center text-white ${rt.primaryButton}`} data-id="element-19706" data-mp="h5quuokg4ygd">
            <PlusIcon className="h-4 w-4 mr-2" data-id="element-19707" data-mp="c7p7vsjwgezm" />
            New Campaign
          </button>
        </div>

        {/* Stats Overview */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-19708" data-mp="7dujibtcnbu7">
          {stats.map(stat => <div key={stat.label} className={`p-6 rounded-xl shadow-sm flex items-center border ${dk.card}`} data-id="element-19709" data-mp="2ehw9pykg2r3">
              <div className={`p-3 rounded-full mr-4 ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`} data-id="element-19710" data-mp="3pkin1x8r3qxr">
                <stat.icon className={`h-6 w-6 ${stat.color}`} data-id="element-19711" data-mp="3kn8x8ghg9d9e" />
              </div>
              <div data-id="element-19712" data-mp="203wshphbbibq">
                <p className={`text-sm ${dk.textMuted}`} data-id="element-19713" data-mp="206j01p47dxty">{stat.label}</p>
                <p className={`text-2xl font-bold ${dk.textPrimary}`} data-id="element-19714" data-mp="251ycccmkblo9">
                  {stat.value}
                </p>
              </div>
            </div>)}
        </div>

        {/* Quick Templates */}
        <section className="mb-8" data-id="element-19715" data-mp="2e3elyi5jzjrf">
          <h2 className={`text-lg font-bold mb-4 ${dk.textPrimary}`} data-id="element-19716" data-mp="1he72dfohvkq5">
            Start from a Template
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4" data-id="element-19717" data-mp="1mc8knye3jg0k">
            {['Newsletter', 'Release Day', 'Sale Alert', 'Cover Reveal'].map(template => <button key={template} className={`p-4 rounded-lg border text-left transition-colors ${rt.hoverBorder} ${dk.card}`} data-id="element-19718" data-mp="1v5v89185hcyo">
                  <div className={`h-8 w-8 rounded-md flex items-center justify-center mb-3 ${rt.bgMedium}`} data-id="element-19719" data-mp="12osrg359sv8n">
                    <FileTextIcon className={`h-4 w-4 ${rt.textPrimary}`} data-id="element-19720" data-mp="jkxpeminppq5" />
                  </div>
                  <h3 className={`font-medium ${dk.textPrimary}`} data-id="element-19721" data-mp="emw0vm2goy7a">
                    {template}
                  </h3>
                  <p className={`text-xs mt-1 ${dk.textMuted}`} data-id="element-19722" data-mp="tc20vc94isg8">
                    Pre-built layout
                  </p>
                </button>)}
          </div>
        </section>

        {/* Campaign List */}
        <div className={`rounded-xl shadow-sm overflow-hidden border ${dk.card}`} data-id="element-19723" data-mp="xclx8dlvhs1b">
          <div className={`px-6 py-4 border-b ${dk.border}`} data-id="element-19724" data-mp="1c9d0wz2kxpwq">
            <h2 className={`font-bold ${dk.textPrimary}`} data-id="element-19725" data-mp="1c6qpgockiq98">Recent Campaigns</h2>
          </div>
          <div className={`divide-y ${dk.divider}`} data-id="element-19726" data-mp="1785rkvksginy">
            {campaigns.map(campaign => <div key={campaign.id} className={`p-6 flex flex-col md:flex-row md:items-center justify-between transition-colors ${darkMode ? 'hover:bg-gray-700/50' : 'hover:bg-gray-50'}`} data-id="element-19727" data-mp="3e2ax94vkf0mf">
                <div className="flex-1 mb-4 md:mb-0" data-id="element-19728" data-mp="1tioymf79ieds">
                  <div className="flex items-center mb-1" data-id="element-19729" data-mp="1tkib4b4k3stp">
                    <h3 className={`font-bold text-lg mr-3 ${dk.textPrimary}`} data-id="element-19730" data-mp="1eshnylnhxznn">
                      {campaign.name}
                    </h3>
                    <span className={`px-2 py-0.5 rounded text-xs font-medium ${campaign.status === 'Sent' ? 'bg-green-100 text-green-800' : campaign.status === 'Scheduled' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-19731" data-mp="1jq9h1izvnrtf">
                      {campaign.status}
                    </span>
                  </div>
                  <p className={`text-sm mb-2 ${dk.textSecondary}`} data-id="element-19732" data-mp="10u9x8vh1zukx">
                    Subject: {campaign.subject}
                  </p>
                  <div className={`flex items-center text-xs ${dk.textFaint}`} data-id="element-19733" data-mp="2v7rbtszhdh3t">
                    {campaign.status === 'Sent' ? <SendIcon className="h-3 w-3 mr-1" data-id="element-19734" data-mp="2trnbqtjv4r85" /> : campaign.status === 'Scheduled' ? <ClockIcon className="h-3 w-3 mr-1" data-id="element-19735" data-mp="2opxyd79641gw" /> : <FileTextIcon className="h-3 w-3 mr-1" data-id="element-19736" data-mp="2jth9uby23l3a" />}
                    {campaign.date} • {campaign.type}
                  </div>
                </div>
                <div className="flex items-center gap-6 md:gap-8" data-id="element-19737" data-mp="3chd4zc7z94xy">
                  {campaign.status === 'Sent' && <div className="flex gap-6" data-id="element-19738" data-mp="37jbngvq79dol">
                      <div className="text-center" data-id="element-19739" data-mp="32raf3kw5k73u">
                        <p className={`text-lg font-bold ${dk.textPrimary}`} data-id="element-19740" data-mp="32pz9dfj5cpa3">
                          {campaign.opens}
                        </p>
                        <p className={`text-xs ${dk.textFaint}`} data-id="element-19741" data-mp="3v7l3ti4n998c">Opens</p>
                      </div>
                      <div className="text-center" data-id="element-19742" data-mp="3qguw3y8qwuah">
                        <p className={`text-lg font-bold ${dk.textPrimary}`} data-id="element-19743" data-mp="3qfbiygidyzcx">
                          {campaign.clicks}
                        </p>
                        <p className={`text-xs ${dk.textFaint}`} data-id="element-19744" data-mp="6lgam4rdcj2u">Clicks</p>
                      </div>
                    </div>}
                  <button className={`p-2 rounded-full ${darkMode ? 'hover:bg-gray-600' : 'hover:bg-gray-100'}`} data-id="element-19745" data-mp="bj83b0zu8983">
                    <MoreVerticalIcon className={`h-5 w-5 ${dk.textFaint}`} data-id="element-19746" data-mp="lj8nsq9g0vdv" />
                  </button>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};
export default EmailCampaigns;